import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {forkJoin, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ContactsService} from '../contacts/contacts.service';
import {BaseService} from '../../../../shared/src/lib/services/base.service';

function select_choice(selected, item) {
  Object.keys(selected).forEach(key => item['contact_' + key] = selected[key]);
}

@Injectable({
  providedIn: 'root'
})
export class PesticidesService extends BaseService {
  public item: any = {};
  public meta: any = {};
  inspectionsService: BaseService;
  noaService: BaseService;

  constructor(public http: HttpClient, private contactsService: ContactsService) {
    super(`${environment.baseUrl}/pesticides/attributes`, http);
    this.inspectionsService = new BaseService(`${environment.baseUrl}/pesticides/inspections`, http);
    this.noaService = new BaseService(`${environment.baseUrl}/pesticides/noa`, http);
  }

  public loadData(search: any): Observable<any> {
    return forkJoin({
      attribute: this.getList(search),
      inspections_meta: this.inspectionsService.loadMetadata(),
      noa_meta: this.noaService.loadMetadata()
    }).pipe(tap(responses => {

      if (responses.attribute.results[0]) {
        merge(this.item, responses.attribute.results[0]);
      } else {
        this.item = {};
      }

      merge(this.meta, responses.attribute.meta);
      this.meta.display_fields = [];
      this.meta.type = 'pesticides/attributes';
      this.meta.urlPath = 'pesticides';
      this.meta.subItems = ['inspections', 'noa', 'contacts'];

      this.meta.fields.inspections = responses.inspections_meta;
      this.meta.fields.inspections.type = 'pesticides/inspections';
      this.meta.fields.inspections.foreign_key_field = 'facility';
      this.meta.fields.inspections.display_fields = ['inspectionid', 'type', 'inspector', 'date', 'date_issued', 'fine',
        'paid', 'balance', 'nov_oc_code', 'compliance_letter', 'remarks', 'compliance_yn', 'nov_oc_yn', 'for_cause_yn'
      ];
      this.meta.fields.inspections.subItems = ['attachments'];
      this.meta.fields.inspections.attachments = {type: 'pesticides/inspections/attach'};

      this.meta.fields.noa = this.loadNOAMetadata(responses.noa_meta)
      this.meta.fields.noa.review = {
        verbose_name_plural: 'Routing/Review',
        verbose_name: 'Review',
        display_fields: ['reviewer', 'status', 'reason', 'order', 'last_edited_date']
      };
      this.meta.fields.contacts = {
        type: 'pesticides/attributes/contacts',
        display_fields: ['relationship_type', 'contact_display_name', 'contact_contact_type'],
        foreign_key_field: 'attributes',
        fields: {
          contact_first_name: {
            get_choices: this.contactsService.meta.fields.contact_first_name.get_choices,
            select_choice: (selected, item) => select_choice(selected, item),
            choices: null
          },
          contact_org_name: {
            get_choices: this.contactsService.meta.fields.contact_org_name.get_choices,
            select_choice: (selected, item) => select_choice(selected, item),
            choices: null
          }
        }
      };
    }));
  }

  loadNOAMetadata(meta: any): any {
    let noaMeta = meta;
    noaMeta.type = 'pesticides/noa';
    noaMeta.foreign_key_field = 'facility';
    noaMeta.display_fields = ['origin', 'port_of_entry',
      'carrier', 'entry_number', 'entry_date', 'marks', 'location', 'invoice_number', 'invoice_date', 'invoice_place',
      'confidential', 'importer_remarks', 'noa_date', 'action', 'action_other',
      'vessel_id', 'vessel_eta', 'application_number', 'submission_date', 'acceptance_date'
    ];


    noaMeta.subItems = ['contacts', 'attachments', 'noaproducts', 'review', 'history'];
    noaMeta.contacts = {
      type: 'pesticides/noa/contacts',
      display_fields: ['relationship_type', 'contact_display_name', 'contact_contact_type'],
      foreign_key_field: 'noa',
      fields: {
        contact_first_name: {
          get_choices: this.contactsService.meta.fields.contact_first_name.get_choices,
          select_choice: (selected, item) => select_choice(selected, item),
          choices: null
        },
        contact_org_name: {
          get_choices: this.contactsService.meta.fields.contact_org_name.get_choices,
          select_choice: (selected, item) => select_choice(selected, item),
          choices: null
        }
      }
    };

    noaMeta.history = {
      display_fields: ['status', 'status_datetime', 'details'],
      type: 'permithistory'
    }

    noaMeta.attachments = {type: 'pesticides/noa/attach'};

    noaMeta.noaproducts = {
      type: 'pesticides/noaproducts',
      display_fields: ['epa_registration_number', 'product_name', 'epa_status', 'container', 'sku', 'epa_establishment_number',
        'ingredients', 'unit_size', 'quantity', 'cases', 'remarks', 'pdf_file'],
      foreign_key_field: 'noa',
      fields: {
        epa_registration_number: {
          get_choices: (s) => {
            // return new Promise(resolve => {
            //   if (s !== {}) {
            // todo: fix cancel for new version of anuglar. same issue as search
            // todo: this is a higher level issue and need to make changes so ALL get_choices functions are returning an observable
            // used to cancel previous request
            // deferred.resolve([]);
            // and start a new one
            // deferred = $q.defer();
            return this.http.get<any>(`${environment.epa_ppls_url}/${s}`).pipe(map(response => {
              return response.items.map(item => {
                return {
                  display_name: item.productname + ' (' + item.eparegno + ')',
                  value: item.eparegno,
                  orig_item: item
                };
              });
            })).toPromise();
            //   } else {
            //     resolve([]);
            //   }
            // });
          },
          select_choice: (selected, item, meta) => {
            item.epa_registration_number = selected.orig_item.eparegno;
            item.product_name = selected.orig_item.productname;
            item.epa_status = selected.orig_item.product_status;
            item.ingredients = selected.orig_item.active_ingredients.map(ingredient => {
              return ingredient.active_ing + ' (' + ingredient.cas_number + ')';
            }).join(', ');
            let t = null;
            let p = '';
            for (const pdf of selected.orig_item.pdffiles) {
              const testDate = new Date(pdf.pdffile_accepted_date);
              if (t === null || t < testDate) {
                t = testDate;
                p = pdf.pdffile;
              }
            }
            item.pdf_file = 'https://www3.epa.gov/pesticides/chem_search/ppls/' + p;
          }
        }
      }

//                subItems: ['attachments'],
//                attachments: {type: 'pesticides/noaproducts/attach'}
    }
    return noaMeta;
  }
}
